var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:!_vm.isLargeScreen ? 'reading-section' : 'note-book'},[_c('div',{staticClass:"line"}),_vm._l((_vm.items),function(item,i){return [_c('p',[_vm._v("\n      "+_vm._s(i)+": "+_vm._s(item.text)+"\n    ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }